import React, {Component} from 'react'

import {RenderLoop} from '../../../_core/utils'

/*
	
	Provide a callback when an item is x% up the viewport

*/

class ViewportProgress extends Component {

	progress=0;

	constructor(props) {
		super(props);
		this.state = {
			stat:0,
			pos:0,
			progress:0,
			height:0,
			distance: 0
		}
	}

	componentDidMount = () => {
		
		
	}

	onFrame= () => {


		let viewPortHeight = window.innerHeight;
		
		let curPos = this.refs.marker.getBoundingClientRect();
		let h = Math.abs(curPos.top - curPos.bottom);

		// Position in viewport
		let pos = curPos.top;

		// How far to travel - default to the viewport plus the height of the object
		let dist = (this.props.distance) ? this.props.distance : viewPortHeight;

		
		// Add the item height to the distance
		dist = (this.props.hasOwnProperty('ignoreHeight')) ? dist : dist + h ;

		// Use the objects height as the distance
		if(this.props.useHeight) dist = h;

		// Add the viewport to the distance
		dist = (this.props.hasOwnProperty('ignoreViewport')) ? (dist - (viewPortHeight)) : dist  ;

		// How much to delay the progress start
		let delayPx = (this.props.delay) ? this.props.delay : 0;

		// When to start the progress
		let start = (this.props.hasOwnProperty('start')) ? this.props.start : viewPortHeight;

		// Minimum allowed progress
		let minProgress = (this.props.hasOwnProperty('minProgress')) ? this.props.minProgress : 0;

		// Maximum allowed progress
		let maxProgress = (this.props.hasOwnProperty('maxProgress')) ? this.props.maxProgress : 1;

		// How far has it travelled?
		let travelled = (start-pos-delayPx);

		let progress = travelled/dist;

		if(this.props.reverse) progress = 1-progress;

		let capProgress = (this.props.hasOwnProperty('capProgress')) ? this.props.capProgress : 1;
		if(capProgress){
			if(progress > maxProgress) progress=maxProgress;
			if(progress < minProgress) progress = minProgress;
		}



		if(progress == this.progress) return;

		this.progress = progress;

		if(this.props.debug){
		this.setState({
			start:start,
			travelled:travelled,
			distance:dist,
			progress: progress,
			height:h,
			pos:pos
		})
		}

		if(this.props.onProgress) this.props.onProgress({progress, pos, travelled, dist});

	}
  render () {

  	let _this = this;
  	let debug;

  	if(this.props.debug){

  		debug = ([<div data-layout-head>
    			<div style={{background:'rgba(0,0,0,0.5)',color:'white',padding:'5px',fontSize:'12px',fontFamily:'monospace'}}>
    				Start: {_this.state.start}<br />
    				Pos: {_this.state.pos}<br/>
    				Travelled:{_this.state.travelled}<br />
    				Distance to cover:{_this.state.distance}<br />
    				Progress:{_this.state.progress}<br/>
    			</div>
    		</div>,
    		<div data-layout-foot>
    			<div style={{background:'rgba(0,0,0,0.5)',color:'white',padding:'5px',fontSize:'12px',fontFamily:'monospace'}}>
    				Start: {_this.state.start}<br />
    				Pos: {_this.state.pos}<br/>
    				Travelled:{_this.state.travelled}<br />
    				Distance to cover:{_this.state.distance}<br />
    				Progress:{_this.state.progress}<br/>
    			</div>
    		</div>,
    		<div data-layout-fluid style={{background:'red',opacity:_this.state.progress}} />]
    		)

  	}
    return (
    	<RenderLoop onFrame={this.onFrame}>

    		

	      	<div data-progress-marker ref={'marker'}>
	      	
	      	{debug}

	      	{this.props.children}

	      	</div>
	      
	    </RenderLoop>
    )
  }
}

export default ViewportProgress



// WEBPACK FOOTER //
// ./src/js/_core/components/ViewportProgress/ViewportProgress.jsx